import { render, staticRenderFns } from "./preStartupReviewItem.vue?vue&type=template&id=333c2b38"
import script from "./preStartupReviewItem.vue?vue&type=script&lang=js"
export * from "./preStartupReviewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333c2b38')) {
      api.createRecord('333c2b38', component.options)
    } else {
      api.reload('333c2b38', component.options)
    }
    module.hot.accept("./preStartupReviewItem.vue?vue&type=template&id=333c2b38", function () {
      api.rerender('333c2b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/psr/preStartupReviewItem.vue"
export default component.exports